module.exports = __webpack_public_path__ + "img/Login-Seite-Ostern.367bbc0b.webp";